import {startNewForm} from './actions/screen';
import {
    closeFormBySession,
    setActiveFormBySession,
    isCurrentSession,
    setCurrentFieldValue,
    canExecuteCommand,
    executeCommand
} from './actions/form';

export function publishNewApi() {
    window['reactForm'] = {};
    window['reactForm']['openForm'] = startNewForm;
    window['reactForm']['closeFormBySession'] = closeFormBySession;
    window['reactForm']['setActiveFormBySession'] = setActiveFormBySession;
    window['reactForm']['isCurrentSession'] = isCurrentSession;
    window['reactForm']['setCurrentFieldValue'] = setCurrentFieldValue;
    window['reactForm']['canExecuteCommand'] = canExecuteCommand;
    window['reactForm']['executeCommand'] = executeCommand;
}
